module.exports = __webpack_public_path__ + "img/circle-clock2.9ebed729.svg";